import React, { useEffect, useState } from 'react';
import { Eye, CheckCircle, Trash2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const AdminSets = () => {
    const [sets, setSets] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        fetchSets();
    }, []);

    const fetchSets = async () => {
        const token = localStorage.getItem('paradise_token');
        const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:4000';
        try {
            // Fetch ALL sets (admin=true)
            const res = await fetch(`${API_BASE}/api/sets?admin=true`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (res.ok) {
                setSets(await res.json());
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    const handlePublish = async (id, currentStatus) => {
        if (currentStatus === 'published') return;
        if (!window.confirm("Publish this set to the live gallery?")) return;

        const token = localStorage.getItem('paradise_token');
        const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:4000';
        try {
            const res = await fetch(`${API_BASE}/api/sets/${id}`, {
                method: 'PATCH',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ status: 'published', publishedAt: new Date().toISOString() })
            });

            if (res.ok) {
                fetchSets();
            }
        } catch (e) {
            console.error(e);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to DELETE this set? This cannot be undone.")) return;

        const token = localStorage.getItem('paradise_token');
        const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:4000';
        try {
            const res = await fetch(`${API_BASE}/api/sets/${id}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (res.ok) {
                fetchSets();
            } else {
                alert("Failed to delete set");
            }
        } catch (e) {
            console.error(e);
            alert("Error deleting set");
        }
    };

    return (
        <div>
            <h2 className="text-2xl font-bold mb-6">Manage Sets</h2>
            {loading ? (
                <div>Loading...</div>
            ) : (
                <div className="grid grid-cols-1 gap-4">
                    {sets.map(set => (
                        <div key={set._id} className="bg-white p-4 rounded-lg shadow-sm border border-gray-100 flex items-center justify-between">
                            <div className="flex items-center space-x-4">
                                <div className="w-16 h-16 bg-gray-100 rounded overflow-hidden">
                                    {set.coverMedia ? (
                                        <img
                                            src={
                                                set.coverMedia.variants?.[0] ||
                                                `https://imagedelivery.net/${process.env.REACT_APP_CLOUDFLARE_ACCOUNT_HASH}/${set.coverMedia.cloudflareImageId || set.coverMedia.id}/public`
                                            }
                                            alt=""
                                            className="w-full h-full object-cover"
                                        />
                                    ) : (
                                        <div className="w-full h-full flex items-center justify-center text-[10px] text-gray-400">NO IMG</div>
                                    )}
                                </div>
                                <div>
                                    <h3 className="font-bold">{set.title}</h3>
                                    <div className="flex items-center space-x-2 text-xs text-gray-500">
                                        <span>Status: <strong className="uppercase">{set.status}</strong></span>
                                        <span>•</span>
                                        <span>Updated: {new Date(set.updatedAt).toLocaleDateString()}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="flex items-center space-x-3">
                                <button
                                    onClick={() => navigate(`/admin/sets/${set._id}`)}
                                    className="p-2 hover:bg-gray-100 rounded text-gray-500"
                                    title="View/Edit"
                                >
                                    <Eye size={18} />
                                </button>
                                <button
                                    onClick={() => handleDelete(set._id)}
                                    className="p-2 hover:bg-red-50 text-red-500 rounded transition-colors"
                                    title="Delete Set"
                                >
                                    <Trash2 size={18} />
                                </button>
                                {set.status !== 'published' && (
                                    <button
                                        onClick={() => handlePublish(set._id, set.status)}
                                        className="flex items-center space-x-2 bg-green-600 text-white px-3 py-2 rounded text-xs font-bold uppercase hover:bg-green-700 transition-colors"
                                    >
                                        <CheckCircle size={14} />
                                        <span>Publish</span>
                                    </button>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default AdminSets;
